import { uuidv4 } from '@core/helpers/uuidv4'

/**
 * Generates a unique identifier prefixed with `__` to distinguish
 * auto-generated IDs from externally provided ones.
 */
export function generateId(): string {
  return `__${uuidv4()}`
}

/**
 * Non-enumerable property key used by builders to signal which fields were
 * explicitly set. The merge logic uses this to allow clearing a field by
 * passing an empty value.
 */
export const EXPLICIT_FIELDS_KEY = '__explicitFields'

/**
 * Attaches the set of explicitly-set field names to a built product or unit
 * as a non-enumerable property. This keeps the metadata invisible to
 * serialization (`JSON.stringify`, `Object.keys`) while remaining accessible
 * to the merge logic via {@link getExplicitFields}.
 */
export function attachExplicitFields(
  target: object,
  fields: Set<string>,
): void {
  Object.defineProperty(target, EXPLICIT_FIELDS_KEY, {
    value: fields,
    enumerable: false,
    writable: false,
    configurable: false,
  })
}

/**
 * Retrieves the set of explicitly-set field names from a product or unit
 * object previously annotated by {@link attachExplicitFields}.
 * Returns `undefined` when the object has no explicit-fields metadata.
 */
export function getExplicitFields(source: unknown): Set<string> | undefined {
  return (source as Record<string, unknown>)?.[EXPLICIT_FIELDS_KEY] as
    Set<string> | undefined
}
